<div class="iframe-container">
  <iframe width = "100%" height="100%" [src] = "fixIframeUrl"></iframe>
  <div class="iframe-overlay"></div>
  <div class="iframe-overlay2"></div>
</div>
